import { Tabs, Timeline } from "antd";
import {
  ClockCircleOutlined,
  UserAddOutlined,
  TagOutlined,
} from "@ant-design/icons";
import styles from "./task-details.module.css";
import { MdOutlineAssignmentInd } from "react-icons/md";

import dayjs from "dayjs";
import { useState } from "react";

// ... (keep existing imports)

const { TabPane } = Tabs;
export interface TaskHistoryItem {
  id: number;
  name: string;
  description: string;
  projectId: number;
  taskId: number;
  statusId: number;
  eventType: string;
  priority: number;
  actualTime: number;
  createdby: number;
  createdon: string; // ISO date string
  projectName: string;
  taskName: string;
  statusName: string;
  assignToUser: string;
  createdByName: string;
  prevStatus?: string; // optional in case it's not always present
}
// New Timeline Component
interface TimelineComponentProps {
  history: TaskHistoryItem[];
}

const TimelineComponent: React.FC<TimelineComponentProps> = ({ history }) => {
  // Dummy history data - replace with API data later
  const dummyHistory = [
    {
      id: 1,
      date: "2024-03-10T14:30:00",
      eventType: "create",
      user: "Admin User",
      description: "Task created in Backlog",
    },
    {
      id: 2,
      date: "2024-03-12T09:15:00",
      eventType: "status",
      user: "Project Manager",
      description: "Status changed to In Progress",
      previousStatus: "Backlog",
      newStatus: "In Progress",
    },
    {
      id: 3,
      date: "2024-03-14T16:45:00",
      eventType: "assignment",
      user: "Team Lead",
      description: "Assigned to John Developer",
    },
  ];

  const getTimelineDot = (eventType: string) => {
    switch (eventType) {
      case "create":
        return <ClockCircleOutlined style={{ fontSize: "16px" }} />;
      case "status":
        return <TagOutlined style={{ fontSize: "16px" }} />;
      case "assignment":
        return <MdOutlineAssignmentInd  style={{ fontSize: "20px" }} />;
      default:
        return <ClockCircleOutlined style={{ fontSize: "16px" }} />;
    }
  };

  return (
    <div className={styles.timelineContainer}>
      <Timeline mode="left">
        {history?.map((item: TaskHistoryItem) => (
          <Timeline.Item
            key={item?.id}
            dot={getTimelineDot(item?.eventType)}
            color="#1890ff"
          >
            <div className={styles.timelineItem}>
              <div className={styles.timelineDate}>
                {dayjs(item?.createdon).format("MMM D, YYYY h:mm A")}
              </div>
              <div className={styles.timelineContent}>
                <div className={styles.timelineHeader}>
                  <span className={styles.timelineUser}>
                    {item?.createdByName}
                  </span>
                    <span
                    className={styles.timelineEvent}
                    dangerouslySetInnerHTML={{ __html: item?.description }}
                    />
                </div>
                <div className={styles.statusChange}>
                  {item?.prevStatus && (
                    <>
                      <span className={styles.oldStatus}>
                        {item?.prevStatus}
                      </span>
                      <span className={styles.statusArrow}>→</span>
                    </>
                  )}
                  <span className={styles.newStatus}>{item?.statusName}</span>
                </div>
              </div>
            </div>
          </Timeline.Item>
        ))}
      </Timeline>
    </div>
  );
};

export default TimelineComponent;
